// src/components/Card.js
import React from "react";
import "./TakashiPlayground.css"; // Ensure styles are included

const Card = ({ children, ...props }) => {
  return <div className="custom-card" {...props}>{children}</div>;
};

export const CardContent = ({ children }) => {
  return <div className="custom-card-content">{children}</div>;
};

export default Card;
